requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    scriptController.executeWhenScriptLoaded(['modal-dialog.js'], () => {
      if (!customElements.get('quick-add-modal')) {
        customElements.define(
          'quick-add-modal',
          class QuickAddModal extends ModalDialog {
            constructor() {
              super();

              this.bodyClasslist.push('quick-add-opened');
              this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
            }

            hide(preventFocus = false) {
              super.hide(() => {
                this.modalContent.innerHTML = '';

                if (preventFocus) this.openedBy = null;
              });
            }

            toggleButton(opener, isLoading) {
              opener[isLoading ? 'setAttribute' : 'removeAttribute']('aria-disabled', true);
              opener.classList.toggle('loading', isLoading);
            }

            show(opener) {
              this.toggleButton(opener, true);
              fetch(opener.getAttribute('data-product-url'))
                .then((response) => response.text())
                .then((responseText) => {
                  responseText = this.removeStickySidebar(lazyTemplateController.cleanHTMLWithTemplate(responseText));
                  const container = document.createElement('div');
                  container.innerHTML = responseText.match(/<section\s+id="MainProduct-[^"]*"[^>]*>.*?<\/section>/s);
                  this.productElement = container.querySelector('section[id^="MainProduct-"]');
                  this.preventDuplicatedIDs();
                  this.removeDOMElements();
                  this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

                  if (window.Shopify && Shopify.PaymentButton) {
                    Shopify.PaymentButton.init();
                  }
                  if (window.ProductModel) {
                    window.ProductModel.loadShopifyXR();
                  }

                  this.removeGalleryListSemantic();
                  this.preventVariantURLSwitching();
                  super.show(opener);
                  window.lazyImages.find(this.modalContent);
                  setTimeout(() => this.toggleButton(opener, false), 300);
                  this.focus();
                });
            }

            setInnerHTML(element, html) {
              element.innerHTML = html;
            }

            preventVariantURLSwitching() {
              const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
              if (!variantPicker) return;

              variantPicker.setAttribute('data-update-url', 'false');
            }

            removeDOMElements() {
              let pickupAvailability = this.productElement.querySelector('pickup-availability');
              if (pickupAvailability) {
                pickupAvailability.remove();
                pickupAvailability = null;
              };

              let productModal = this.productElement.querySelector('product-modal');
              if (productModal) {
                productModal.remove();
                productModal = null;
              }

              const modalDialog = this.productElement.querySelectorAll('modal-dialog');
              if (modalDialog) modalDialog.forEach((modal) => {
                modal.remove();
                modal = null;
              });
            }

            preventDuplicatedIDs() {
              const sectionId = this.productElement.dataset.section;
              this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
              this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
                element.dataset.originalSection = sectionId;
              });
            }

            removeStickySidebar(html) {
              return html.replace(/<sticky-sidebar/g, '<div').replace(/<\/sticky-sidebar/g, '</div');
            }

            removeGalleryListSemantic() {
              const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
              if (!galleryList) return;

              galleryList.setAttribute('role', 'presentation');
              galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
            }





          }
        );
      }
    });
  });
});